import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import moment from "moment";
import { post } from "../../../../helpers/api_helper";
import {
  POST_BranchDDLList,
  POST_GetCustomerProjectList,
  POST_GetReportCustomerOutstandingExport,
  POST_GetReportCustomerOutstandingList,
  POST_GetReportCustomerOutstandingRegisterExport,
  POST_GetReportCustomerOutstandingRegisterList,
} from "../../../../helpers/url_helper";

import CustomSelect from "../../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../../CustomControls/CustomFlatpickr";
import { errorMessage } from "../../CommonFunctions";

const CustomerOutstandingReport = () => {
  const [showFilter, setShowFilter] = useState(true); //for report screen default true
  const [isLoading, setIsLoading] = useState(false);

  const [isReset, setIsReset] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [outstandingList, setOutstandingList] = useState([]);
  const [outstandingRegisterTotal, setOutstandingRegisterTotal] = useState({});
  const [outstandingReportTotal, setOutstandingReportTotal] = useState({});
  const [customerProjectOptions, setCustomerProjectOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);

  const reportTypeOptions = [
    { label: "Outstanding Register", value: 1 },
    { label: "Outstanding Report", value: 2 },
  ];

  const typeOptions = [
    { label: "Summary", value: true },
    { label: "Detail", value: false },
  ];

  const currentDate = new Date();

  const validationSchemaFilter = Yup.object().shape({
    BranchIDEncrypt: Yup.string().required("Branch is required field"),
  });

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      ReportType: 1,
      FromDate: new Date(currentDate.setMonth(currentDate.getMonth() - 3)),
      ToDate: new Date(),
      BranchIDEncrypt: "",
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      IsSummaryReport: true,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ReportType,
      FromDate,
      ToDate,
      BranchIDEncrypt,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      IsSummaryReport,
    },
  } = formikFilter;

  const handleValidSubmitFilter = (values) => {
    getData();
  };

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      ReportType: 1,
      FromDate: new Date(currentDate.setMonth(currentDate.getMonth() - 3)),
      ToDate: new Date(),
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      IsSummaryReport: true,
    });

    setIsReset(true);
  };

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    if (isReset == true) {
      getData();
      setIsReset(false);
    }
  }, [isReset]);

  const getBranchDDL = async () => {
    await post(POST_BranchDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      EmployeeIDEncrypted: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setBranchOptions(
            response?.BranchList?.map((item) => ({
              label: item?.BranchName,
              value: item?.BranchIDEncrypted,
              IsBranchDefinationComplate: item?.IsBranchDefinationComplate,
            }))
          );
          if (response?.BranchList?.length > 0) {
            formikFilter.setFieldValue(
              "BranchIDEncrypt",
              response?.BranchList[0].BranchIDEncrypted
            );
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getData = async () => {
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: BranchIDEncrypt,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      IsSummaryReport: IsSummaryReport,
    };

    await post(
      ReportType == 1
        ? POST_GetReportCustomerOutstandingRegisterList
        : POST_GetReportCustomerOutstandingList,
      payload
    )
      .then((response) => {
        setOutstandingList(response?.List);
        if (ReportType == 1) {
          let sumOfOutstandingRegister = calculateColumnSumsOutstandingRegister(
            response?.List
          );
          setOutstandingRegisterTotal(sumOfOutstandingRegister);
        }
        if (ReportType == 2) {
          let subOfOutstandingReport = calculateColumnSumsOutstandingReport(
            response?.List
          );
          setOutstandingReportTotal(subOfOutstandingReport);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  const exportReport = () => {
    if (ReportType == 2 && !BranchIDEncrypt) {
      formikFilter.setFieldError("BranchIDEncrypt", "Branch is required field");
      formikFilter.setFieldTouched("BranchIDEncrypt", true);
      return;
    }

    setIsLoading(true);
    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: BranchIDEncrypt,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      IsSummaryReport: IsSummaryReport,
      ReportGenerateByIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    };

    post(
      ReportType == 1
        ? POST_GetReportCustomerOutstandingRegisterExport
        : POST_GetReportCustomerOutstandingExport,
      payload
    )
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerProjectDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item?.ProjectName,
              value: item?.CustomerProjectIDEncrypt,
            }))
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted
            ).length == 0
          ) {
            formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeReportType = (e) => {
    formikFilter.setFieldValue("ReportType", e?.value ?? "");
    setOutstandingList([]);
    if (e && e?.value == 1) {
      formikFilter.setFieldValue("IsSummaryReport", true);
      formikFilter.setFieldValue("CustomerIDEncrypted", "");
      formikFilter.setFieldValue("CustomerName", "");
      formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");

      formikFilter.setFieldError("CustomerIDEncrypted", "");
      formikFilter.setFieldTouched("CustomerIDEncrypted", false);
    }
  };

  const handleChangeType = (e) => {
    formikFilter.setFieldValue("IsSummaryReport", e?.value ?? "");
    setOutstandingList([]);
  };

  const calculateColumnSumsOutstandingRegister = (data) => {
    return data?.reduce(
      (sums, item) => {
        sums.TotalInvoiceAmount += parseFloat(item.TotalInvoiceAmount) || 0;
        sums.TotalReceivedAmount += parseFloat(item.TotalReceivedAmount) || 0;
        sums.TotalPendingAmount += parseFloat(item.TotalPendingAmount) || 0;
        sums.AdvanceBalanceAmount += parseFloat(item.AdvanceBalanceAmount) || 0;
        return sums;
      },
      {
        TotalInvoiceAmount: 0,
        TotalReceivedAmount: 0,
        TotalPendingAmount: 0,
        AdvanceBalanceAmount: 0,
      }
    );
  };

  const calculateColumnSumsOutstandingReport = (data) => {
    return data?.reduce(
      (sums, item) => {
        sums.TotalInvoiceAmount += parseFloat(item.InvoiceAmount) || 0;
        sums.TotalReceivedAmount += parseFloat(item.ReceivedAmount) || 0;
        sums.TotalPendingAmount += parseFloat(item.PendingAmount) || 0;
        return sums;
      },
      {
        TotalInvoiceAmount: 0,
        TotalReceivedAmount: 0,
        TotalPendingAmount: 0,
      }
    );
  };

  useEffect(() => {
    getCustomerProjectDDL();
    getBranchDDL();
  }, []);

  useEffect(() => {
    getData();
  }, [BranchIDEncrypt]);

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Outstanding Report</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore me-2" aria-hidden="true"></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>

                  <Link
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <Field
                              label="Report Type"
                              name="ReportType"
                              placeholder={"Select Report Type"}
                              options={reportTypeOptions}
                              component={CustomSelect}
                              isClearable={false}
                              onChange={handleChangeReportType}
                            />
                          </Col>

                          {ReportType == 2 && (
                            <Col lg={1}>
                              <Field
                                label="Type"
                                name="IsSummaryReport"
                                placeholder={"Select Type"}
                                options={typeOptions}
                                component={CustomSelect}
                                isClearable={false}
                                onChange={handleChangeType}
                              />
                            </Col>
                          )}

                          <Col lg={2}>
                            <label className="mb-1">Financial Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Branch"
                              name="BranchIDEncrypt"
                              placeholder={"Select Branch"}
                              options={branchOptions}
                              component={CustomSelect}
                              isClearable={false}
                              required
                            />
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Project"
                              name="CustomerProjectIDEncrypted"
                              placeholder={"Select Project"}
                              options={customerProjectOptions}
                              component={CustomSelect}
                              menuStyles={{
                                position: "absolute",
                                right: 0,
                              }}
                            />
                          </Col>

                          <Col lg={1}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <button
                                  className="btn btn-primary btn-sm mb-1"
                                  type="submit"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div className="table-responsive">
                  <div
                    id="OutstandingReports-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                    style={{ height: "510px", overflowY: "auto" }}
                  >
                    {ReportType == 1 && (
                      <table
                        id="OutstandingRegister-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead className="fixedheader">
                          <tr>
                            <th width="3%" style={{ textAlign: "center" }}>
                              #
                            </th>
                            <th width="57%">Customer Name</th>
                            <th width="10%" style={{ textAlign: "right" }}>
                              Invoice Amount
                            </th>
                            <th width="10%" style={{ textAlign: "right" }}>
                              Received Amount
                            </th>
                            <th width="10%" style={{ textAlign: "right" }}>
                              Pending Amount
                            </th>
                            <th width="10%">Balance Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {outstandingList?.length > 0 ? (
                            <>
                              {outstandingList?.map((item, index) => (
                                <tr key={index}>
                                  <td style={{ textAlign: "center" }}>
                                    {item?.RowNo}
                                  </td>
                                  <td>{item?.CustomerName}</td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.TotalInvoiceAmount}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.TotalReceivedAmount}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.TotalPendingAmount}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.AdvanceBalanceAmount}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td colSpan={2} style={{ textAlign: "right" }}>
                                  <label className="mb-0 me-2">Total</label>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {outstandingRegisterTotal?.TotalInvoiceAmount.toFixed(
                                      2
                                    )}
                                  </label>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {outstandingRegisterTotal?.TotalReceivedAmount.toFixed(
                                      2
                                    )}
                                  </label>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {outstandingRegisterTotal?.TotalPendingAmount.toFixed(
                                      2
                                    )}
                                  </label>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {outstandingRegisterTotal?.AdvanceBalanceAmount.toFixed(
                                      2
                                    )}
                                  </label>
                                </td>
                              </tr>
                            </>
                          ) : (
                            <tr>
                              <td colSpan={6} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {ReportType == 2 && (
                      <table
                        id="OutstandingReport-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead className="fixedheader">
                          <tr>
                            <th
                              width="2%"
                              style={{ minWidth: "50px", textAlign: "center" }}
                            >
                              #
                            </th>

                            <th width="6%" style={{ minWidth: "110px" }}>
                              Invoice Date
                            </th>
                            <th width="7%" style={{ minWidth: "140px" }}>
                              Invoice No
                            </th>
                            {IsSummaryReport == false && (
                              <>
                                <th width="7%" style={{ minWidth: "280px" }}>
                                  Inward No
                                </th>
                                <th width="7%" style={{ minWidth: "280px" }}>
                                  TC No
                                </th>
                                <th
                                  width="6%"
                                  style={{
                                    minWidth: "120px",
                                    textAlign: "right",
                                  }}
                                >
                                  Gross Amount
                                </th>
                                <th
                                  width="6%"
                                  style={{
                                    minWidth: "120px",
                                    textAlign: "right",
                                  }}
                                >
                                  Other Expense
                                </th>
                                <th
                                  width="6%"
                                  style={{
                                    minWidth: "120px",
                                    textAlign: "right",
                                  }}
                                >
                                  Discount Amount
                                </th>
                                <th
                                  width="6%"
                                  style={{
                                    minWidth: "110px",
                                    textAlign: "right",
                                  }}
                                >
                                  GST Amount
                                </th>
                                <th
                                  width="6%"
                                  style={{
                                    minWidth: "110px",
                                    textAlign: "right",
                                  }}
                                >
                                  Rounding Off
                                </th>
                              </>
                            )}
                            <th
                              width="7%"
                              style={{ minWidth: "120px", textAlign: "right" }}
                            >
                              Invoice Amount
                            </th>
                            <th
                              width="7%"
                              style={{ minWidth: "120px", textAlign: "right" }}
                            >
                              Received Amount
                            </th>
                            <th
                              width="7%"
                              style={{ minWidth: "120px", textAlign: "right" }}
                            >
                              Pending Amount
                            </th>
                            <th width="6%" style={{ minWidth: "120px" }}>
                              Due On
                            </th>
                            <th width="7%" style={{ textAlign: "left" }}>
                              Overdue Days
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {outstandingList?.length > 0 ? (
                            <>
                              {outstandingList?.map((item, index) => (
                                <tr key={index}>
                                  <td style={{ textAlign: "center" }}>
                                    {item?.RowNo}
                                  </td>

                                  <td>{item?.InvoiceDate}</td>
                                  <td>{item?.InvoiceNo}</td>
                                  {IsSummaryReport == false && (
                                    <>
                                      <td
                                        style={{
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {item?.InwardNo}
                                      </td>
                                      <td
                                        style={{
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {item?.TCNo}
                                      </td>
                                      <td style={{ textAlign: "right" }}>
                                        {item?.GrossAmount}
                                      </td>
                                      <td style={{ textAlign: "right" }}>
                                        {item?.OtherExpense}
                                      </td>
                                      <td style={{ textAlign: "right" }}>
                                        {item?.DiscountAmount}
                                      </td>
                                      <td style={{ textAlign: "right" }}>
                                        {item?.GSTAmount}
                                      </td>
                                      <td style={{ textAlign: "right" }}>
                                        {item?.RoundingOff}
                                      </td>
                                    </>
                                  )}
                                  <td style={{ textAlign: "right" }}>
                                    {item?.InvoiceAmount}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.ReceivedAmount}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.PendingAmount}
                                  </td>
                                  <td>{item?.DueOn}</td>
                                  <td style={{ textAlign: "center" }}>
                                    {item?.OverdueDays}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td
                                  colSpan={IsSummaryReport == false ? 10 : 3}
                                  style={{ textAlign: "right" }}
                                >
                                  <label className="mb-0 me-2">Sub Total</label>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {outstandingReportTotal?.TotalInvoiceAmount.toFixed(
                                      2
                                    )}
                                  </label>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {outstandingReportTotal?.TotalReceivedAmount.toFixed(
                                      2
                                    )}
                                  </label>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {outstandingReportTotal?.TotalPendingAmount.toFixed(
                                      2
                                    )}
                                  </label>
                                </td>
                                <td colSpan={2}></td>
                              </tr>
                              <tr>
                                <td
                                  colSpan={IsSummaryReport == false ? 10 : 3}
                                  style={{ textAlign: "right" }}
                                >
                                  <label className="mb-0 me-2">
                                    On Account
                                  </label>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {outstandingList[0]?.AdvanceBalanceAmount}
                                  </label>
                                </td>
                                <td></td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {outstandingList[0]?.AdvanceBalanceAmount}
                                  </label>
                                </td>
                                <td colSpan={2}></td>
                              </tr>
                              <tr>
                                <td
                                  colSpan={IsSummaryReport == false ? 10 : 3}
                                  style={{ textAlign: "right" }}
                                >
                                  <label className="mb-0 me-2">
                                    Total Outstanding
                                  </label>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {parseFloat(
                                      outstandingReportTotal?.TotalInvoiceAmount
                                    ) -
                                      parseFloat(
                                        outstandingList[0]
                                          ?.AdvanceBalanceAmount ?? 0
                                      ) >
                                    0
                                      ? (
                                          parseFloat(
                                            outstandingReportTotal?.TotalInvoiceAmount
                                          ) -
                                          parseFloat(
                                            outstandingList[0]
                                              ?.AdvanceBalanceAmount ?? 0
                                          )
                                        ).toFixed(2)
                                      : "0.00"}
                                  </label>
                                </td>
                                <td></td>
                                <td style={{ textAlign: "right" }}>
                                  <label className="mb-0">
                                    {parseFloat(
                                      outstandingReportTotal?.TotalPendingAmount
                                    ) -
                                      parseFloat(
                                        outstandingList[0]
                                          ?.AdvanceBalanceAmount ?? 0
                                      ) >
                                    0
                                      ? (
                                          parseFloat(
                                            outstandingReportTotal?.TotalPendingAmount
                                          ) -
                                          parseFloat(
                                            outstandingList[0]
                                              ?.AdvanceBalanceAmount ?? 0
                                          )
                                        ).toFixed(2)
                                      : "0.00"}
                                  </label>
                                </td>
                                <td colSpan={2}></td>
                              </tr>
                            </>
                          ) : (
                            <tr>
                              <td colSpan={16} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default CustomerOutstandingReport;
